/**
 * @group UI
 * @summary UI resource name constants
 * 
 * @remarks
 * This constant contains resource names used in UI components
 * for consistent resource handling and logging.
 * 
 * @example
 * ```typescript
 * import { UI_RESOURCES } from '@shared/constants';
 * 
 * logger.error('Error in form submission', { resource: UI_RESOURCES.DASHBOARD });
 * ```
 */
export const UI_RESOURCES = {
  DASHBOARD: 'dashboard',
  USERS: 'users',
  ROLES: 'roles',
  TENANTS: 'tenants',
  PERMISSIONS: 'permissions'
} as const;
